import { makeStyles } from '@material-ui/core';
import React from 'react';
import { useAnswerContext } from './context';
import { Footer, Intro, MainFrom, Result, Survey, Contact } from './pages';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

export const App = () => {
  const classes = useStyles();
  const { isComplete, inProgress } = useAnswerContext();

  return (
    <>
      <div className={classes.root}>
        {!isComplete && <Intro />}
        {!isComplete && !inProgress ? <MainFrom /> : null}
        {!isComplete && inProgress ? <Survey /> : null}
        {isComplete ? <Result /> : null}
      </div>
      <Contact isComplete={isComplete} />
      <Footer />
    </>
  );
};
